import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { AiOutlineHome, AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";

const Contact = () => {
  const smallCardItems = [
    {
      Icon: AiOutlineHome,
      name: "Location",
      desc: "Dhaka, Bangladesh",
    },
    {
      Icon: BsTelephone,
      name: "Phone",
      desc: "+8801955477668",
    },
    {
      Icon: AiOutlineMail,
      name: "Email",
      desc: "fahimshariar28@gmail.com",
    },
  ];

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_cq7efjc",
        "template_g3bcu2c",
        form.current,
        "sySgbYN4EKpaCkyXK"
      )
      .then(
        (result) => {
          Swal.fire({
            icon: "success",
            title: "Your Email has been sent",
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(result.text);
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div
      name="contact"
      className="w-full bg-gradient-to-b from-black to-gray-800 p-4 text-white"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Contact
          </p>
          <p className="py-6">Submit the form below to get in touch with me</p>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4">
          <div className="flex flex-col gap-4">
            {smallCardItems.map((item) => (
              <div
                key={item.name}
                className="flex items-center gap-4 p-4 lg:p-6 shadow rounded shadow-blue-400"
              >
                <div className="text-3xl p-2 rounded-full bg-primary text-blue-400">
                  <item.Icon />
                </div>
                <div className="flex flex-col">
                  <span className="font-semibold text-blue-400">
                    {item.name}
                  </span>
                  <span className="text-sm">{item.desc}</span>
                </div>
              </div>
            ))}
          </div>
          <form
            ref={form}
            onSubmit={sendEmail}
            className="flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="user_name"
              placeholder="Enter your name"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="text"
              name="user_email"
              placeholder="Enter your email"
              className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>

            <button className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
              Let's Talk
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
